import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastService } from "src/app/services/toast.service";
import { ModalController } from "@ionic/angular";
import { ApactaApiSdkService } from "src/app/services/apacta-api-sdk.service";
import { DefaultApiInterface, LabelEntity } from "@apacta/sdk/src";
import { sentryCaptureException } from "src/app/utility/errors";

@Component({
    selector: "app-labels",
    templateUrl: "./labels.component.html",
    styleUrls: ["./labels.component.scss"],
    standalone: false,
})
export class LabelsComponent implements OnInit {
    @Input() entity!: string;
    @Input() multiSelect: boolean = false;
    @Input() inputSelectedLabels: string[] = [];
    @Input() hasResetButton: boolean = false;
    @Output() onLabelSelect = new EventEmitter();

    public labels: LabelEntity[] = [];
    public loading = true;

    private selectedLabels: string[] = [];
    private defaultSdk: DefaultApiInterface;

    constructor(
        private modalCtrl: ModalController,
        private toastService: ToastService,
        private apactaSdk: ApactaApiSdkService
    ) {}

    ngOnInit() {
        this.selectedLabels = this.inputSelectedLabels || [];
        this.defaultSdk = this.apactaSdk.configuration();
        this.getLabels();
    }

    public getLabels() {
        this.defaultSdk
            .getLabels({ entity: this.entity })
            .then((labels) => {
                if (labels?.data.length === 0) {
                    this.modalCtrl.dismiss();
                    this.toastService.showToastMessage("TOAST.NO_LABELS_FOUND", {
                        color: "danger",
                        position: "top",
                        showCloseButton: true,
                        duration: 3000,
                    });
                    return;
                }

                this.labels = labels.data;
                this.loading = false;
            })
            .catch((err) => {
                this.modalCtrl.dismiss();
                sentryCaptureException(err);
                this.toastService.showGeneralErrorMessage();
            });
    }

    public selectLabel(label: LabelEntity): void {
        if (!label) {
            return;
        }

        this.onLabelSelect.emit(label);
        this.modalCtrl.dismiss();
    }

    public removeSelection(): void {
        this.onLabelSelect.emit();
        this.modalCtrl.dismiss();
    }

    public isLabelSelected(labelId: string): boolean {
        return this.selectedLabels.includes(labelId);
    }

    public onLabelItemClick(labelId: string): void {
        const isChecked = this.isLabelSelected(labelId);
        this.toggleMultiSelectLabel(labelId, !isChecked);
    }

    public toggleMultiSelectLabel(labelId: string, checked: boolean): void {
        if (checked) {
            this.selectedLabels.push(labelId);
        } else {
            this.selectedLabels = this.selectedLabels.filter((id) => id !== labelId);
        }
    }

    public confirm(): void {
        this.onLabelSelect.emit(this.selectedLabels);
        this.modalCtrl.dismiss();
    }
}
